<template>
  <div style="min-height:900px">
    <div
      v-if="incomingProgramNotFound"
      class="notification is-warning"
      style="max-width:600px;margin-bottom:2rem">
      <button
        class="delete"
        @click="incomingProgramNotFound = false"
      />
      <strong>Program not found</strong> - This program either no longer exists or is currently full.
    </div>
    <div v-if="!programs.length">
      No Programs are available at this time.
    </div>
    <div
      v-else
      class="program-order"
      style="max-width:600px;margin:0 0 3rem;padding:1rem;border:1px solid #e1e8ee;background:#f7f7f7;position:relative">
      <a
        v-show="step > 1"
        href="#"
        style="font-size:0.8em;border:0;position:absolute;top:1rem;right:1.5rem"
        @click.prevent="step = step - 1">
        &lt; go back
      </a>

      <transition name="pop-out-quick">
        <div v-show="step == 1">
          <div class="field is-grouped">
            <div class="field-body">
              <div
                v-if="programs.length"
                class="field">
                <div>Select Program</div>
                <div
                  class="field"
                  style="margin-bottom:0.5rem">
                  <div class="control">
                    <span class="select">
                      <select
                        v-model="program"
                        :class="{'is-danger':btnPressed && !program.length}"
                        name="child[grade]">
                        <option value="">Please select</option>
                        <option
                          v-for="program in programs"
                          :key="program.id"
                          :value="program.id">
                          {{ program.name }}
                        </option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
<!--              <transition name="pop-out-quick">-->
<!--                <div-->
<!--                  v-if="selectedProgram && selectedProgram.inventory > 0"-->
<!--                  class="field"-->
<!--                  style="width:50%">-->
<!--                  <div style="border-bottom:1px solid #ddd">Inventory</div>-->
<!--                  <div class="field">-->
<!--                    <div class="control">-->
<!--                      <div-->
<!--                        style="height:36px;display:flex;align-items:center"-->
<!--                        class="">-->
<!--                        Remaining seats: {{ selectedProgram.inventory }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </transition>-->
            </div>
          </div>

          <div>Child Information</div>
          <div class="field-group-gray">

            <div class="field">
              <div class="control">
                <label class="label">Child's Full Name</label>
                <input
                  :class="{'input':true, 'is-large':false, 'is-danger':btnPressed && !child.name.length}"
                  v-model="child.name"
                  autocomplete="name"
                  type="text"
                  name="child[name]">
              </div>
            </div>

            <div class="field is-grouped">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <label class="label">Birthday</label>
                    <input
                      :class="{'input':true, 'is-large':false, 'is-danger':btnPressed && !child.bday.length}"
                      v-model="child.bday"
                      autocomplete="bday"
                      type="date"
                      name="child[bday]">
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">Grade</label>
                    <span class="select">
                      <select
                        v-model="child.grade"
                        :class="{'is-danger':btnPressed && !child.grade.length}"
                        name="child[grade]">
                        <option value="">Please select</option><option value="0K">Kindergarten</option><option value="1">1st Grade</option><option value="2">2nd Grade</option><option value="3">3rd Grade</option><option value="4">4th Grade</option><option value="5">5th Grade</option><option value="6">6th Grade</option><option value="7">7th Grade</option><option value="8">8th Grade</option><option value="9">9th Grade</option><option value="10">10th Grade</option><option value="11">11th Grade</option><option value="12">12th Grade</option>
                      </select>
                    </span>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">Gender</label>
                    <input
                      :class="{'input':true, 'is-large':false, 'is-danger':btnPressed && !child.gender.length}"
                      v-model="child.gender"
                      autocomplete="sex"
                      type="text"
                      name="child[gender]">
                  </div>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <label class="label">Allergies/Medical Concerns</label>
                <textarea
                  v-model="child.allergies"
                  class="textarea"
                  autocomplete="off"
                  name="child[allergies]"/>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <label class="label">Additional information (shy, grumpy when hungry, etc.)</label>
                <textarea
                  v-model="child.additionalInfo"
                  class="textarea"
                  autocomplete="off"
                  name="child[additionalInfo]"/>
              </div>
            </div>

          </div>
          <div>
            <button
              class="button turquoise-button"
              style="margin-bottom:0.25rem;padding-top:0;padding-bottom:0"
              @click.prevent="showStepTwo()">Next</button>
          </div>
        </div>
      </transition>

      <transition name="pop-out-quick">
        <div v-show="step == 2">
          <div>Parent Information</div>
          <div class="field-group-gray">
            <div class="field is-grouped">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <label class="label">Full Name</label>
                    <input
                      v-model="parent.name"
                      :class="{'input':true, 'is-large':false, 'is-danger':btnTwoPressed && !parent.name.length}"
                      autocomplete="name"
                      type="text"
                      name="parent[name]">
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">Parent Contact Email</label>
                    <input
                      v-model="parent.email"
                      :class="{'input':true, 'is-large':false, 'is-danger':btnTwoPressed && !parent.email.length}"
                      autocomplete="email"
                      type="email"
                      name="parent[email]">
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-grouped">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <label class="label">Primary Phone (home)</label>
                    <input
                      v-model="parent.phone"
                      :class="{'input':true, 'is-large':false, 'is-danger':btnTwoPressed && !parent.phone.length}"
                      autocomplete="tel"
                      type="text"
                      name="parent[phone]">
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label">Additional Phone (cell)</label>
                    <input
                      v-model="parent.cell"
                      :class="{'input':true, 'is-large':false, 'is-danger':btnTwoPressed && !parent.cell.length}"
                      autocomplete="tel"
                      type="text"
                      name="parent[phone]">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>Address</div>
          <div class="field-group-gray">

            <div class="field">
              <label class="label">Street</label>
              <div class="control">
                <input
                  v-model="parent.address.street"
                  :class="{'is-danger':btnTwoPressed && !parent.address.street.length}"
                  name="parent[address][street]"
                  autocomplete="street-address"
                  class="input">
              </div>
            </div>

            <div class="field is-grouped">
              <div class="field-body">
                <div class="field">
                  <label class="label">City</label>
                  <div
                    style="max-width:300px;"
                    class="control">
                    <input
                      v-model="parent.address.city"
                      :class="{'is-danger':btnTwoPressed && !parent.address.city.length}"
                      name="parent[address][city]"
                      autocomplete="address-level2"
                      class="input">
                  </div>
                </div>
                <div class="field">
                  <label class="label">State</label>
                  <div
                    style="max-width:200px;"
                    class="control">
                    <input
                      v-model="parent.address.state"
                      :class="{'is-danger':btnTwoPressed && !parent.address.state.length}"
                      name="parent[address][state]"
                      autocomplete="address-level1"
                      class="input">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Zip</label>
                  <div
                    style="max-width:100px;"
                    class="control">
                    <input
                      v-model="parent.address.zip"
                      :class="{'is-danger':btnTwoPressed && !parent.address.zip.length}"
                      name="parent[address][state]"
                      autocomplete="postal-code"
                      class="input">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              class="button turquoise-button"
              style="margin-bottom:0.25rem;padding-top:0;padding-bottom:0"
              @click.prevent="showCheckout()">Checkout</button>
          </div>
        </div>
      </transition>

      <transition name="pop-out-quick">
        <div v-show="step == 3">
          <h4>Checkout</h4>
          <div class="field">
            <div class="control">
              <table class="table is-striped">
                <thead>
                  <tr>
                    <th style="text-align:right">Item</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:right">{{ programName }}</td>
                    <td>{{ formatAsCurrency(programPrice) }}</td>
                  </tr>
                  <tr>
                    <td style="text-align:right">Total:</td>
                    <td>{{ formatAsCurrency(programPrice) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <form
            class="field-group-gray"
            role="form"
            @submit.prevent="submitToStripe()">

            <div class="field">
              <label class="label">Cardholder's Name</label>
              <div
                style="max-width:300px;"
                class="control">
                <input
                  v-model="card.name"
                  :class="{'is-danger':btnCheckoutPressed && !card.name.length}"
                  name="card[name]"
                  autocomplete="name"
                  class="input">
              </div>
            </div>

            <div class="field">
              <label class="label">Credit or Debit Card</label>
              <div class="control">
                <div
                  id="card-element"
                  :class="{'input':true, 'is-danger':card.error }"
                  style="display:inline-block"/>
              </div>
              <p
                v-if="card.error"
                class="help is-danger"
                role="alert">{{ card.error }}</p>
            </div>
          </form>
          <div
            class="field"
            style="display:flex;justify-content:flex-end">
            <a
              :disabled="card.processing"
              class="button is-success"
              @click.prevent="submitToStripe()">
              <template v-if="card.processing">
                <span
                  class="icon is-small"
                  style="margin-right:1px">
                  <i class="fa fa-spin fa-spinner"/>
                </span> Processing
              </template>
              <template v-else>Pay {{ formatAsCurrency(programPrice) }}</template>
            </a>
          </div>
        </div>
      </transition>

      <p
        v-if="error"
        class="help is-danger"
        role="alert">{{ error }}</p>
    </div>
  </div>
</template>
 
<script>
  export default {
    components: {
    },
    props: {
      programs: {
        type: Array,
        default: () => {}
      },
      logo: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        error: false,
        incomingProgramNotFound: false,
        program: '',
        child: {
          name: "",
          bday: "",
          grade: "",
          gender: "",
          allergies: '',
          additionalInfo: ''
        },
        parent: {
          name: '',
          email: '',
          phone: '',
          cell: '',
          address: {
            street: '',
            city: '',
            state: '',
            zip: ''
          },
        },
        card: {
          instance: '',
          name: '',
          processing: false,
        },
        btnPressed: false,
        btnTwoPressed: false,
        btnCheckoutPressed: false,
        step: 1
      }
    },
    computed: {
      selectedProgram() {
        if (!this.programs) return false
        let program = this.programs.find(program => {
          return program.id == this.program
        })
        return program ? program : null
      },
      programName() {
        return this.selectedProgram ? this.selectedProgram.name : ''
      },
      programPrice() {
        return this.selectedProgram ? this.selectedProgram.price : ''
      }
    },
    watch: {
      program() {
          this.updateUrl()
      }
    },
    created() {
      if (this.programs) {
        let url = new URL(window.location.href)
        let programParam = url.searchParams.get('program')
        let program = this.programs.find(program => {
          return program.id == programParam
        })
        this.program = program ? program.id : ''
        this.updateUrl()

        if (programParam && !this.program) {
          this.incomingProgramNotFound = true
        }
      }
    },
    methods: {
      showStepTwo() {
        this.btnPressed = true
        this.error = ''

        // Add some defaults
        this.child.allergies = this.child.allergies || 'NA'
        this.child.additionalInfo = this.child.additionalInfo || 'NA'

        // Look for empty fields
        if (_.includes(this.child, '')) {
          this.error = 'Oops! Look like you\'re missing some information.'
          return;
        }
        this.step = 2
      },
      updateUrl() {
        // Update the URL to reflect their selected program, in case they share the URL
        let query = window.queryString.parse(location.search)
        query.program = this.program
        query = this.program ? '?' + window.queryString.stringify(query) : ''

        let url = window.location.href.split('?')[0] + query
        window.history.replaceState({}, null, url)
      },
      showCheckout() {
        this.btnTwoPressed = true
        this.error = ''

        // Look for empty fields
        if (_.includes(this.parent, '')) {
          this.error = 'Oops! Look like you\'re missing some information.'
          return;
        }
        if (_.includes(this.parent.address, '')) {
          this.error = 'Address is required'
          return false
        }
        if (!this.validateEmail(this.parent.email)) {
          this.error = 'Invalid email'
          return false
        }
        this.step = 3
        this.$nextTick(() => {
          this.card.instance || this.createStripeCard()
        })
      },
      formatAsCurrency(num) {
        return '$' + (parseFloat(num) / 100).toFixed(2);
      },
      createStripeCard() {
        const style = {
          base: {
            color: '#333333',
            fontSize: '18px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#767676',
            },
          },
          invalid: {
            color: '#ff385f',
            ':focus': {
              color: '#ff385f',
            },
          },
        };
        this.card.instance = elements.create('card', {style});
        this.card.instance.mount('#card-element');
        this.card.instance.addEventListener('change', ({error}) => {
          this.card.error = (error) ? error.message : '';
        });
      },
      validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
      },
      submitToStripe() {
        this.btnCheckoutPressed = true
        this.error = ''
        if (!this.card.name) {
          this.error = 'Cardholder\'s Name is required'
          return false
        }

        if (!this.selectedProgram) {
          this.error = 'There appears to be an error with the selected program'
          return false
        }

        this.card.processing = true;
        stripe.createToken(this.card.instance, {
          name: this.card.name
        }).then((result) => {
          if (result.error) {
            this.card.processing = false;
            this.card.error = result.error.message
            return false
          } else {
            // Send the token to the server
            axios.post('/slickfish/v1/program/purchase', {
              name: this.card.name,
              email: this.parent.email,
              token: result.token.id,
              program: this.selectedProgram.id,
              child: this.child,
              parent: this.parent,
            }).then(response => {
              this.card.processing = false;
              swal({
                title: 'Success!',
                text: 'You have successfully signed up and will be receiving an email from us shortly with more information.',
                type: 'success',
                confirmButtonColor: '#025c39',
              }).then(function () {
                window.location.reload()
              });
            }).catch(error => {
              this.card.processing = false;
              var errorMessage = error.response.data.message;
              swal({
                title: 'Error',
                text: 'There was an error, you can try again. If it continues, please contact us immediately. ' + errorMessage,
                type: 'error',
                confirmButtonColor: '#ff385f',
                confirmButtonText: 'OK'
              });
            });
          }
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
  .label {
    font-size: 0.9em;
    font-weight: 500;
    margin-bottom: 0!important;
    margin-top: 0.25rem!important;
  }
  .field-group-gray {
    margin-bottom: 2rem !important;
    background: #f9f9f9;
    padding: 1rem;
    border: 1px solid #e4e4e4;
  }
</style>


// WEBPACK FOOTER //
// assets/js/ProgramCheckout.vue